import React from 'react';
import logo from '@/src/assets/images/Paradigm-Math-logo-dark.png';

const DistrictAdminDashboard: React.FC = () => {
    document.title = 'Dashboard';

    return (
        <div
            style={{
                position: 'relative',
                height: '50vh',
                overflow: 'hidden',
                width: '50vw',
            }}
        >
            <img
                src={logo}
                alt="Paradigm Math Logo"
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '500px',
                    opacity: 0.5,
                    pointerEvents: 'none',
                    zIndex: 0,
                    userSelect: 'none',
                }}
            />
        </div>
    );
};

export default DistrictAdminDashboard;
